import { Component, Input } from '@angular/core';
import { Milestone } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor } from '@freelancer/ui/button';
import {
  MilestoneConfirmModalResponse,
  MilestoneConfirmModalType,
} from './milestone-confirm-modal.types';

@Component({
  template: `
    <fl-bit [ngSwitch]="confirmType">
      <ng-container
        *ngSwitchCase="MilestoneConfirmModalType.REQUEST_CANCEL"
        i18n="Milestone cancellation request confirmation modal"
      >
        Are you sure you want to request the freelancer to cancel this milestone?
      </ng-container>
      <ng-container
        *ngSwitchCase="MilestoneConfirmModalType.CANCEL"
        i18n="Milestone cancellation confirmation modal"
      >
        Are you sure you want to cancel this milestone?
      </ng-container>
      <ng-container
        *ngSwitchCase="MilestoneConfirmModalType.REQUEST_RELEASE"
        i18n="Milestone release request confirmation modal"
      >
        Are you sure you want to request the employer to release?
      </ng-container>
      <ng-container
        *ngSwitchCase="MilestoneConfirmModalType.RELEASE"
        i18n="Milestone releast confirmation modal"
      >
        Are you sure you want to release this milestone to the freelancer?
      </ng-container>
    </fl-bit>

    <fl-button
      i18n="Milestone confirmation modal button"
      [color]="ButtonColor.DEFAULT"
      (click)="onCancel()"
    >
      Close
    </fl-button>

    <fl-button
      i18n="Milestone confirmation modal button"
      [color]="ButtonColor.SECONDARY"
      (click)="onConfirm()"
    >
      Confirm
    </fl-button>
  `,
})
export class MilestoneConfirmModalComponent {
  ButtonColor = ButtonColor;
  MilestoneConfirmModalType = MilestoneConfirmModalType;

  @Input() milestone: Milestone;
  @Input() confirmType: MilestoneConfirmModalType;

  constructor(private modalRef: ModalRef<MilestoneConfirmModalComponent>) {}

  onConfirm() {
    this.modalRef.close(MilestoneConfirmModalResponse.SUCCESS);
  }

  onCancel() {
    this.modalRef.close(MilestoneConfirmModalResponse.FAILURE);
  }
}
